import { RouteObject } from "react-router-dom";
import BillingSummary from "./components/BillCycleSummary";
import CreateBillCycle from "./components/landing/CreateBillCycle";
import Landing from "./components/landing/landing";
import CreateUpdateCycle from "../bill-cycle-v2/create/CreateUpdateCycle";
import BillCycleDetail from "../bill-cycle-v2/detail/BillCycleDetail";
export interface BillCycleRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BillCycleRoute[];
}
export const bxBillCycleRoutes: BillCycleRoute[] = [
  {
    path: "/bx/bill-setup/billcycle",
    element: <Landing />,
  },
  {
    path: "/bx/bill-setup/billcycle/detail/:id",
    element: <BillCycleDetail />,
  },
  {
    path: "/bx/bill-setup/billcycle/action/:action",
    element: <CreateUpdateCycle />,
  },
  {
    path: "/bx/bill-setup/billcycle/action/:action/:id",
    element: <CreateUpdateCycle />,
  },
  {
    path: "/bx/bill-setup/billcycle/summary/:id",
    element: <BillingSummary />,
  },
];
